class OrderService {

  /*@ngInject*/
  constructor($resource, $window) {
    this.$resource = $resource;
    this.$window = $window;
  }

  retrieveOrderConfirmation(orderId) {
    return this.$resource('/bathrooms/cart/secure/service/orders/:orderId/confirmation').get({
      orderId: orderId
    }).$promise;
  }
  
  retrieveOrderDetails(orderId) {

    var Order = this.$resource('/bathrooms/cart/secure/service/orders/:orderId', {orderId: orderId}, {
      'getOrder': {
        method: 'GET',
        headers: {'origin_company_id': this.$window.companyIdentifier}
      }
    });    
    
    return Order.getOrder().$promise;
  }

  retrieveOrderHistoryModel() {
    return this.$resource('/bathrooms/cart/secure/service/orders').query().$promise;
  }
}

export default OrderService;


// WEBPACK FOOTER //
// ./src/app/services/order-service.js